(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

var _linkPageTop = _interopRequireDefault(require("./module/linkPageTop.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* module ==============================*/

/* scroll to top ==============================*/
var scrollTop = new _linkPageTop["default"]('.scroll-top');
/* JQuery Functions ==============================*/

(function ($) {
  /* carousel ==============================*/
  if (window.innerWidth < 768) {
    $('.carouselWrapper._isBlockSp').on('init', function (event, slick, direction) {
      scrollTop.init();
    });
  } else {
    $('.carouselWrapper._isBlockTab').on('init', function (event, slick, direction) {
      scrollTop.init();
    });
  }

  $('.carouselWrapper._isBlockSp').slick({
    accessibility: true,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 3000,
    cssEase: 'ease-out',
    dots: true,
    draggable: true,
    infinite: true,
    initialSlide: 0,
    pauseOnHover: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 600,
    swipe: true
  });
  $('.carouselWrapper._isBlockTab').slick({
    accessibility: true,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 3000,
    cssEase: 'ease-out',
    dots: true,
    draggable: true,
    infinite: true,
    initialSlide: 0,
    pauseOnHover: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 600,
    swipe: true,
    responsive: [{
      breakpoint: 767,
      settings: {
        centerMode: true,
        centerPadding: '0',
        dots: true,
        slidesToShow: 1
      }
    }]
  });
})(jQuery);

},{"./module/linkPageTop.js":2}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

/**
 * ページトップリンク
 * @module linkPageTop
 * @constructor
 * @param {HTMLElement} element - 適用対象
 * @param {object} option - オプション
 * @param {string} option.fixTarget - スクロール追従停止対象
 * @param {string} option.visibleHeight - 表示開始スクロール位置
 * @param {string} option.duration - 表示エフェクト所要時間
 */
var linkPageTop = /*#__PURE__*/function () {
  function linkPageTop(element, option) {
    _classCallCheck(this, linkPageTop);

    this.object = document.querySelector(element);
    this.option = option ? option : {};
    this.fixTarget = this.option.fixTarget ? document.querySelector(this.option.fixTarget) : undefined;
    this.visibleHeight = this.option.visibleHeight ? this.option.visibleHeight : 500;
    this.duration = this.option.duration ? this.option.duration : 300;
  }

  _createClass(linkPageTop, [{
    key: "display",
    value: function display() {
      var _this = this;

      var contentHeight = document.body.clientHeight;
      var windowHeight = window.innerHeight;

      var fadeFunc = function fadeFunc(object, method) {
        var timer = 0;

        if (method === 'on') {
          object.classList.remove('_isHidden');
          clearTimeout(timer);
          timer = setTimeout(function () {
            object.classList.remove('-invisible');
          }, 100);
        } else {
          clearTimeout(timer);
          object.classList.add('-invisible');
          timer = setTimeout(function () {
            object.classList.add('_isHidden');
          }, _this.duration);
        }
      };

      if (contentHeight - windowHeight > this.visibleHeight) {
        if (window.pageYOffset >= this.visibleHeight) {
          if (this.object.classList.contains('_isHidden')) fadeFunc(this.object, 'on');
        } else {
          if (!this.object.classList.contains('_isHidden')) fadeFunc(this.object, 'off');
        }
      }
    }
  }, {
    key: "positionFix",
    value: function positionFix() {
      var contentHeight = document.body.clientHeight;
      var windowHeight = window.innerHeight;
      var targetHeight = this.fixTarget ? this.fixTarget.clientHeight : 0;

      if (contentHeight - windowHeight - targetHeight + this.object.clientHeight < window.pageYOffset) {
        this.object.classList.remove('-fixed');
      } else {
        this.object.classList.add('-fixed');
      }
    }
  }, {
    key: "scroll",
    value: function scroll() {
      var _this2 = this;

      window.addEventListener('scroll', function () {
        _this2.display();

        _this2.positionFix();
      });
    }
  }, {
    key: "init",
    value: function init() {
      var _this3 = this;

      try {
        if (!this.object) throw 'There is no element to apply the "linkPageTop"';
        this.display();
        this.positionFix();
        this.scroll();
        var timer = 0;
        window.addEventListener('resize', function () {
          clearTimeout(timer);
          timer = setTimeout(function () {
            _this3.display();

            _this3.positionFix();
          }, 200);
        });
      } catch (error) {
        console.log(error);
      }
    }
  }]);

  return linkPageTop;
}();

exports["default"] = linkPageTop;

},{}]},{},[1]);
